import { Approval } from "../interfaces/Approval";
import { IFilteredTenants } from "../interfaces/IFilteredTenants";

export interface ResidentsState {
  // residents: IFilteredTenants;
  approvals: Array<Approval>
}

export const initialResidentsState: ResidentsState = {
  // residents: undefined,
  approvals: []
}